<template>
  <div class="text-whitebase relative">
    <div class="absolute z-0 inset-0 overflow-hidden">
      <img
        class="w-full h-0 md:h-full object-cover"
        :src="require('@/assets/bgs/top100.png')"
        alt=""
      />
    </div>
    <div
      class="
        px-4
        md:px-0
        mx-auto
        max-w-1200px
        relative
        z-10
        pt-6
        md:pt-23.5
        pb-0
        md:pb-26.5
        flex
        justify-end
      "
    >
      <div class="text-left" style="max-width: 665px">
        <h1 class="pb-2 md:pb-4 text-2xl md:text-4xl font-bold">
          ANNUAL RANKING
        </h1>
        <p class="text-sm text-white-080">
          In 2023, a landmark year for crypto and Decentralized Autonomous
          Organizations (DAOs), the DAO ecosystem experienced unprecedented
          growth, with DAO treasuries expanding from $19.86 billion to $31.94
          billion, a 60.8% increase. The number of DAOs (56,020 up), voters
          (4,581,300 up), and proposals (166,153 up) also saw significant rises,
          highlighting the need for recognition and assessment in this rapidly
          evolving sector. DAO100, the pivotal initiative by DAOBase, aims to
          honor and recognize the most influential DAOs and their key
          contributors, underscoring their significant role in the decentralized
          ecosystem.
        </p>
<!--        <SeeMoreTextDialog-->
<!--          v-else-->
<!--          displayed-text-style="max-w-914px max mx-auto text-xs md:text-base text-white-080"-->
<!--          :text="{-->
<!--            titleText: 'DAO 100 2023: ',-->
<!--            mainText:-->
<!--              'In 2023, a landmark year for crypto and Decentralized Autonomous Organizations (DAOs), the DAO ecosystem experienced unprecedented growth, with DAO treasuries expanding from $19.86 billion to $31.94 billion, a 60.8% increase. The number of DAOs (56,020 up), voters (4,581,300 up), and proposals (166,153 up) also saw significant rises, highlighting the need for recognition and assessment in this rapidly evolving sector. DAO100, the pivotal initiative by DAOBase, aims to honor and recognize the most influential DAOs and their key contributors, underscoring their significant role in the decentralized ecosystem.',-->
<!--          }"-->
<!--        />-->
      </div>
    </div>
  </div>
</template>
<script setup>
import { useDesktop } from '@/hooks';
import SeeMoreTextDialog from './SeeMoreTextDialog.vue';
const isDesktop = useDesktop('md');
</script>
<style></style>
